/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { fetchTimeout } from "./Common";
import { Palette, API_BASE } from "../AppConfig";
import HelpIcon from "@material-ui/icons/Help";
import IconButton from "@material-ui/core/IconButton";
import { Drawer } from "@material-ui/core";
import BSL_Button from "./BSL_Button";
import Message from "./Message";
import { toggleAPP, updateAPP } from "../redux_store/appState";

const useStyles = makeStyles({
    root: {},
    paper: {
        padding: "125px 20px 20px 20px",
        minWidth: "500px",
        maxWidth: "25%",
        backgroundColor: "#EDF0F3",
    },
});

export default function HelpButton(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const editorRef = React.useRef(null);
    const app = useSelector((state) => state.app);

    const [open, setOpen] = React.useState(props.open);
    const [showMessage, setShowMessage] = React.useState(false);
    const [content, setContent] = React.useState("loading...");

    const toggleHelp = () => {
        dispatch(toggleAPP("help_open", !app?.help_open)).then(() => {
            if (!app?.help_open && props?.section) dispatch(updateAPP("help_section", props?.section));
            else dispatch(updateAPP("help_section", ""));
        });
    };

    React.useEffect(() => {
        if (props.content === "blocking") {
            let help_base_url = API_BASE() + "document/help";
            fetchTimeout(help_base_url + "/blocking", {
                method: "GET",
            })
                // .then(res => (res.ok ? res : Promise.reject(res)))
                .then(async (res) => {
                    if (!res.ok) Promise.reject(res);
                    else {
                        let text = await res.text();
                        setContent(text);
                    }
                });
        }
    }, [props.content, open]);

    const setBlock = (style) => {
        document.execCommand("formatblock", false, style);
    };
    const save = () => {
        if (props.content === "blocking") {
            let help_base_url = API_BASE() + "document/help";
            fetchTimeout(help_base_url + "/blocking", {
                method: "PUT",
                body: JSON.stringify({
                    document_type: "help",
                    document_name: "blocking",
                    document_data: editorRef.current.innerHTML,
                }),
            })
                // .then(res => (res.ok ? res : Promise.reject(res)))
                .then(async (res) => {
                    if (!res.ok) Promise.reject(res);
                    else {
                        let text = await res.text();
                        

                        setShowMessage({
                            type: "success",
                            message: "Content saved for '" + props.content + "'",
                        });
                    }
                });
        }
    };

    let editable = false;
    if (app.user.Role >= 99) editable = true;

    return (
        <>
            {window.LYSAGHT && (
                <BSL_Button
                    style={{ marginLeft: "108px", minWidth: "24px", borderRadius: "3px" }}
                    tight
                    onClick={() => {
                        toggleHelp(!open);
                    }}
                >
                    ?
                </BSL_Button>
            )}
            {window.FIELDERS && (
                <IconButton
                    style={{ marginLeft: "40px", color: Palette.Control.Grey }}
                    onClick={() => {
                        toggleHelp(!open);
                    }}
                >
                    <HelpIcon />
                </IconButton>
            )}
            <Drawer
                classes={{ paper: classes.paper }}
                anchor={"right"}
                open={open}
                variant={"persistent"}
                BackdropProps={{ invisible: true }}
                onClose={() => {
                    setOpen(false);
                }}
            >
                {editable && (
                    <div
                        style={{
                            position: "fixed",
                            background: "white",
                            marginTop: "-20px",
                            marginLeft: "-20px",
                            width: "100%",
                        }}
                    >
                        <div style={{ display: "flex" }}>
                            <div
                                style={{
                                    fontSize: "10px",
                                    color: "dark red",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                }}
                            >
                                EDIT:{" "}
                            </div>
                            <BSL_Button label={"Heading"} tight secondary onClick={() => setBlock("h2")} />
                            <BSL_Button label={"Sub-Heading"} tight secondary onClick={() => setBlock("h3")} />
                            <BSL_Button label={"Paragraph"} tight secondary onClick={() => setBlock("p")} />
                            <BSL_Button label={"SAVE"} tight onClick={save} />
                        </div>
                    </div>
                )}
                <div ref={editorRef} contentEditable={editable} dangerouslySetInnerHTML={{ __html: content }}></div>
            </Drawer>
            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />
        </>
    );
}

//  function Blocking() {

//   return (
//     <>

//     <h2>Blocking</h2>
//     <p>The number of sides blocked is an ffessential part of the formula Design Suite uses to calculate the uplift wind pressure and in selecting the correct members to carry those wind loads, so make sure you’re selecting the correct value.
// You should consider nearby structures on either side of a fence or wall when determining the correct blocking to use. The more sides blocked, the higher the wind uplift unless completely blocked on all four sides (a.k.a. 4B).
// If you’re uncertain which option to choose, refer to a suitable qualified engineer, or choose the higher number of sides blocked.</p>
// <br />

// <h3>*this help page is still under development*</h3>
//     </>
//   )

//  }
